<template>
  <div id="dgr-card-overlay">
    <v-hover>
      <template v-slot:default="{ hover }">
        <v-card class="mx-auto" width="344" height="400">
          <v-img :src="getPathImg(image)"></v-img>

          <v-card-text style="height: 112px">
            <h4 class="card-title">{{ title }}</h4>
            <p class="card-subtitle">{{ subTitle }}</p>
          </v-card-text>

          <v-fade-transition>
            <v-overlay v-if="hover" absolute color="#036358">
              <!-- <v-btn>See more info</v-btn> -->
            </v-overlay>
          </v-fade-transition>

          <v-card-actions>
            <v-row justify="center">
              <v-icon>mdi-eye</v-icon>
              <p class="pt-2 pl-1">ดูรายละเอียดเพิ่มเติม</p>
            </v-row>
          </v-card-actions>
        </v-card>
      </template>
    </v-hover>
  </div>
</template>

<script>
export default {
  name: "DgrCardOverlay",
  props: {
    title: String,
    subTitle: String,
    description: String,
    image: String,
  },
  methods: {
    getPathImg(image) {
      return require(`@/assets/images/card/${image}`);
    },
  },
};
</script>

<style>
</style>